import { Box, Button } from '@mui/material';
import { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';

// Page Container
export const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.5),
  },
}));

// Header section containing title and action buttons
export const PageHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

// Title section with fixed width
export const TitleSection: React.ComponentType<BoxProps> = styled(Box)(() => ({
  flex: '0 0 25%',
}));

// Action button container for multiple buttons
export const ActionButtonContainer = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
  },
}));

// Register member button - consistent with companies and properties pages
export const CreateMemberButton = styled(Button)(({ theme }) => ({
  minWidth: '50%',
  height: '40px',
  textTransform: 'none',
  borderRadius: theme.spacing(3),
  fontWeight: 600,
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    height: '40px',
  },
}));
